const cargoPackagingTypeValues = [
    'unspecified',
    'unpackaged',
    'euro-pallet',
    'industrial-pallet',
    'one-way-pallet',
    'cage-pallet',
    'cardboard-box',
    'rack',
    'roll-container',
    'big-bag',
    'ibc',
    'coil',
    'transport-rack',
    'trailer',
] as const;

export type CargoPackagingTypes = (typeof cargoPackagingTypeValues)[number];
export const cargoPackagingTypes: CargoPackagingTypes[] = [...cargoPackagingTypeValues];
export const isCargoPackagingType = (value?: string): value is CargoPackagingTypes =>
    typeof value === 'string' && cargoPackagingTypes.some(type => type === value);

export type BulkPackagingTypes = 'bulk-material';
export const bulkPackagingTypes: BulkPackagingTypes[] = ['bulk-material'];
export const isBulkPackagingType = (value?: string): value is BulkPackagingTypes =>
    typeof value === 'string' && bulkPackagingTypes.some(type => type === value);

export type PackagingTypes = CargoPackagingTypes | BulkPackagingTypes;
